import { FC } from 'react'
import MasterCard from '../../assets/logos-mastercard.svg?react'
import VisaCard from '../../assets/logos-visa-bg.svg?react'
import Typography from '../atoms/Typography'
import DeletePaymentDialog from '../organisms/dialogs/DeletePaymentDialog'
import { IPaymentMethod, useMakeDefaultPaymentMethod } from 'src/enviroment/api/services/paymentMethodsApi'
import { enqueueSnackbar } from 'notistack'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { cn } from 'src/enviroment/lib/utils'

interface PaymentMethodProps {
  method: IPaymentMethod
  isDelete?: boolean
}

export const PaymentMethod: FC<PaymentMethodProps> = ({ method, isDelete }) => {
  const { id, brand, last4, isDefault } = method
  const { mutate: makeDefault, isLoading } = useMakeDefaultPaymentMethod()

  const handleMakeDefault = (checked: CheckboxPrimitive.CheckedState) => {
    if (checked && !isDefault) {
      makeDefault(id, {
        onSuccess: () => {
          enqueueSnackbar('Default payment method updated', { variant: 'success' })
        },
        onError: () => {
          enqueueSnackbar('Failed to update default payment method', { variant: 'error' })
        },
      })
    }
  }

  const renderLogoCard = () => {
    switch (brand) {
      case 'visa':
        return (
          <div className="items-center rounded-md px-2 py-1">
            <VisaCard width={33} height={33} />
          </div>
        )
      case 'mastercard':
        return (
          <div className="items-center rounded-md">
            <MasterCard width={33} height={33} />
          </div>
        )
      default:
        return null
    }
  }

  return (
    <div className="flex h-10 w-full flex-row items-center justify-between">
      <div aria-describedby="payment-methods" className="flex flex-1 flex-row items-center gap-4">
        <CheckboxPrimitive.Root
          checked={isDefault}
          disabled={isLoading}
          onCheckedChange={handleMakeDefault}
          className={cn(
            'h-5 w-5 rounded-full border border-light-green-500 ring-offset-white',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-light-green-500 focus-visible:ring-offset-2',
            'disabled:cursor-not-allowed disabled:border-light-green-300 disabled:bg-light-green-300',
            'transition-colors duration-200',
            isDefault && 'border-light-green-500',
          )}
        >
          <CheckboxPrimitive.Indicator className="flex h-full w-full items-center justify-center">
            <span className="h-3 w-3 rounded-full bg-light-green-500" />
          </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>
        <div>{renderLogoCard()}</div>
        <Typography variant="base" className="ml-1 text-light-green-50">
          **** **** **** {last4} {isDefault && '(Default)'}
        </Typography>
      </div>
      <div aria-describedby="actions-buttons">{isDelete && <DeletePaymentDialog method={method} />}</div>
    </div>
  )
}
